exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.select2-dropdown {\n\t\tz-index: 9001;\n}\n.custom-chat {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n}\n.text-area {\n        height: 3em;\n        display: flex;\n        margin-top: 1em;\n        margin-left: 1em;\n        margin-right: 2em;\n        margin-bottom: 0.5em;\n}\n.mensagens {\n\t\tflex: 1;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\toverflow-y: auto;\n}\n", ""]);

// exports
